/** Utilidades de formato para la UI. */

import type { MarcaTiempo } from '@cji/shared';

const MESES = ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'];

/** Convierte un Timestamp de Firestore a Date (o null). */
export function aFecha(t: MarcaTiempo | null | undefined): Date | null {
  if (!t) return null;
  try {
    return t.toDate();
  } catch {
    return null;
  }
}

/** Formato corto de fecha, estilo del sistema legado: 06-JUL-2026. */
export function fmtFecha(t: MarcaTiempo | null | undefined): string {
  const d = aFecha(t);
  if (!d) return '—';
  return `${String(d.getDate()).padStart(2, '0')}-${MESES[d.getMonth()]}-${d.getFullYear()}`;
}

/** Fecha y hora legibles (zona horaria de Colombia). */
export function fmtFechaHora(t: MarcaTiempo | null | undefined): string {
  const d = aFecha(t);
  if (!d) return '—';
  return d.toLocaleString('es-CO', { timeZone: 'America/Bogota' });
}

/** Clase CSS para la insignia de un estado. */
export function claseBadge(estado: string): string {
  return 'badge ' + estado.toLowerCase();
}

/** Traduce un mensaje de error de Cloud Functions a algo legible. */
export function mensajeError(e: unknown): string {
  const err = e as { message?: string; code?: string };
  return err?.message || 'Ocurrió un error inesperado.';
}
